import {
  Component,
  OnInit,
  HostListener,
  Input,
  OnDestroy,
} from '@angular/core';
import { BreezeService } from 'src/app/shared/services/breeze.service';
import { SearchParams, StationInfo, TrainInfo } from '../../models/breeze';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  NgbCalendar,
  NgbDate,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { BreakpointObserverService } from 'src/app/shared/services/breakpoint.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter, take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        NgbDropdownModule,
        NgOptimizedImage,
        NgbAlertModule,
    ]
})
export class SearchBoxComponent implements OnInit, OnDestroy {
  searchResults: TrainInfo[] = [];
  gettingSearchResults: boolean | undefined;
  stations: StationInfo[] = [];
  form: FormGroup = new FormGroup({});
  private today: any;
  private searchParams: SearchParams | undefined;
  @Input('readonly') readonly: boolean = false;

  prices: any[] = [];
  mode: 'local' | '' = '';
  lineStations1: StationInfo[] = [];
  lineStations2: StationInfo[] = [];
  lineStations3: StationInfo[] = [];
  route: number = 0;
  private trainConfig: any;
  isMobile: boolean = false;
  productList: any[] = [];
  userName: string = '';
  sub = new Subscription();
  message: string | null = null;
  showAdminBanner = false;
  datePickerDisabled: any = true;
  isAuth = false;

  constructor(
    private datePipe: DatePipe,
    private breezeService: BreezeService,
    private fb: FormBuilder,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private storage: StorageService,
    private breakpointService: BreakpointObserverService,
    private router: Router,
    private calendar: NgbCalendar,
  ) {}

  @HostListener('window:resize', ['$event'] as any)
  onResize(): void {
    this.checkScreenSize();
  }

  checkScreenSize(): void {
    this.isMobile = window.innerWidth < 1200;
  }

  get depatureDate() {
    return this.form.get('date');
  }
  get adult() {
    return this.form.get('adult');
  }

  get minor() {
    return this.form.get('minor');
  }

  get passenger() {
    return this.form.get('passenger');
  }

  get source() {
    return this.form.get('sourceStation1');
  }

  get minDepatureDate(): any {
    let date = new Date(this.today);
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
  }

  // get maxDepatureDate(): any {
  //   const days = Math.max(this.trainConfig?.maxDaysForScheduleList ?? 7, 7);
  //   return this.calendar?.getNext(this.minDepatureDate, 'd', days - 1);
  // }

  get maxDepatureDate(): any {
    let prodExt = environment.production
      ? this.trainConfig?.maxDaysForScheduleList - 1
      : 6;
    let date: any = this.trainConfig
      ? this.calendar?.getNext(this.minDepatureDate, 'd', prodExt)
      : this.minDepatureDate;
    return date;
  }

  ngOnInit(): void {
    const userData = this.storage.get('user');
    if (userData && userData.name && userData.family) {
      this.userName = `${userData?.name}`;
    } else {
    }
    this.sub.add(
      this.breezeService.isAuthListener.subscribe((res) => {
        this.isAuth = res;
        if (res) {
          const userData = this.storage.get('user');
          this.userName = `${userData?.name}`;
        } else {
          this.userName = '';
        }
      }),
    );
    this.breezeService.getIsAuthListener();

    if (this.router.url.includes('passenger-info')) {
      this.readonly = true;
    }
    this.router.events.subscribe({
      next: (event) => {
        if (event instanceof NavigationEnd) {
          if (this.router.url.includes('passenger-info')) {
            this.readonly = true;
          }
        }
      },
    });

    this.breakpointService.size$.subscribe((size) => {
      this.isMobile = size === 'xs';
    });
    this.form = this.fb.group({
      sourceStation1: ['', [Validators.required]],
      sourceStationName: ['', [Validators.required]],
      sourceAbbreviation: ['', [Validators.required]],
      destinationStation1: ['', [Validators.required]],
      destinationStationName: ['', [Validators.required]],
      destinationAbbreviation: ['', [Validators.required]],
      date: ['', [Validators.required]],
      passenger: [1, [Validators.required]],
      adult: [1, [Validators.required]],
      minor: [0, [Validators.required]],
      price: ['', [Validators.required]],
    });
    // this.checkSearchParams();

    this.breezeService.getSearchParams().subscribe((searchParams) => {
      this.searchParams = searchParams;
      if (this.searchParams) {
        const today: NgbDate = new NgbDate(
          this.minDepatureDate.year,
          this.minDepatureDate.month,
          this.minDepatureDate.day,
        );
        const storedDate = new Date(this.searchParams?.date);
        if (
          today.after({
            year: storedDate.getFullYear(),
            month: storedDate.getMonth() + 1,
            day: storedDate.getDate(),
          })
        ) {
          this.searchParams.date = this.today;
        }
        this.form.patchValue(this.searchParams);
        this.mode = 'local';
      }
      this.getStations();
      this.getserverTime();
    });
    // this.getStations();
    this.getCoachTypes();
    this.getProductList();
    this.checkScreenSize();

    const previewMessage = this.getBannerPreviewMessage();
    if (previewMessage) {
      this.showAdminBanner = true;
      this.message = this.formatBannerMessage(previewMessage);
      return;
    }

    this.loadBannerMessage();
  }

  loadBannerMessage(): void {
    this.sub.add(
      this.breezeService.getMessage().subscribe({
        next: (response: any) => {
          const rawMessage = response?.value;
          const hasMessage =
            typeof rawMessage === 'string' && rawMessage.trim().length > 0;

          this.showAdminBanner =
            hasMessage && this.isBannerActive(response?.date_created);
          this.message = this.showAdminBanner
            ? this.formatBannerMessage(rawMessage)
            : null;
        },
        error: () => {
          this.showAdminBanner = false;
          this.message = null;
        },
      }),
    );
  }

  private isBannerActive(dateCreated: string | null | undefined): boolean {
    if (!dateCreated) {
      return true;
    }

    const createdAt = new Date(dateCreated);
    if (Number.isNaN(createdAt.getTime())) {
      return true;
    }

    const twentyFourHoursInMs = 24 * 60 * 60 * 1000;
    return Date.now() - createdAt.getTime() <= twentyFourHoursInMs;
  }

  private formatBannerMessage(message: string): string {
    const normalizedMessage = this.stripWrappingQuotes(message.trim());
    return this.escapeHtml(normalizedMessage).replace(/\r\n|\r|\n/g, '<br />');
  }

  private stripWrappingQuotes(value: string): string {
    const hasDoubleQuotes = value.startsWith('"') && value.endsWith('"');
    const hasSingleQuotes = value.startsWith("'") && value.endsWith("'");

    if (hasDoubleQuotes || hasSingleQuotes) {
      return value.slice(1, -1).trim();
    }

    return value;
  }

  private getBannerPreviewMessage(): string | null {
    const previewParams = new URLSearchParams(window.location.search);
    const isPreviewEnabled = previewParams.get('bannerPreview') === '1';

    const messageFromQuery = previewParams.get('bannerMessage');
    if (isPreviewEnabled && messageFromQuery?.trim()) {
      return messageFromQuery;
    }

    const messageFromStorage = localStorage.getItem('bannerPreviewMessage');
    if (messageFromStorage?.trim()) {
      return messageFromStorage;
    }

    return null;
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  getCoachTypes() {
    this.breezeService.getCoachTypes().subscribe((res: any) => {
      this.prices = res.coachTypeViews;
      this.searchParams
        ? null
        : this.form.get('price')?.patchValue(this.prices[0].name);
    });
  }

  checkSource() {
    const source: string = String(this.source?.value);
    switch (source.charAt(0)) {
      case '1':
        this.route = 1;
        break;
      case '2':
        this.route = 2;
        break;
      case '3':
        this.route = 3;
        break;
      default:
        break;
    }
  }

  getserverTime() {
    this.breezeService.getServerTime().subscribe((date) => {
      this.datePickerDisabled = false;
      this.today = new Date(date.date).toISOString().split('T')[0];
      if (this.mode === 'local') {
        return;
      }
      this.searchParams ? null : this.onDateSelected(this.minDepatureDate);
    });
  }

  getStations() {
    this.breezeService.getStations().subscribe((stations: StationInfo[]) => {
      this.stations = stations;
      this.trainConfig = this.storage.get('trainConfig');
      this.lineStations1 = this.stations.filter((element) => {
        return element.stationCode.toString().charAt(0) == '1';
      });
      this.lineStations2 = this.stations.filter((element) => {
        return element.stationCode.toString().charAt(0) == '2';
      });
      this.lineStations3 = this.stations.filter((element) => {
        return element.stationCode.toString().charAt(0) == '3';
      });
      if (this.mode == 'local') {
        return;
      }
      this.searchParams ? null : this.updateSource(this.stations[0]);
      this.searchParams
        ? null
        : this.updateDestination(this.stations[this.stations.length - 1]);
    });
  }

  updateSource(station: StationInfo) {
    this.form.patchValue({
      sourceStation1: station.stationCode,
      sourceStationName: station.stationName,
      sourceAbbreviation: station.abbreviation,
    });
    this.form.updateValueAndValidity();
    this.checkSource();
  }

  updateDestination(station: StationInfo) {
    this.form.patchValue({
      destinationStation1: station.stationCode,
      destinationStationName: station.stationName,
      destinationAbbreviation: station.abbreviation,
    });
    this.form.updateValueAndValidity();
  }

  updatePassengers(passengers: any) {
    this.form.patchValue({
      passenger: passengers,
    });
    this.form.updateValueAndValidity();
    this.updateSearchParams();
  }

  onSwapStations() {
    const formData = this.form.value;
    this.form.patchValue({
      destinationStation1: formData.sourceStation1,
      sourceStation1: formData.destinationStation1,
      destinationStationName: formData.sourceStationName,
      sourceStationName: formData.destinationStationName,
      destinationAbbreviation: formData.sourceAbbreviation,
      sourceAbbreviation: formData.destinationAbbreviation,
    });

    this.form.updateValueAndValidity();
  }

  onDateSelected(selectedDate: NgbDate) {
    const date = new Date(
      `${selectedDate.year}/${selectedDate.month}/${selectedDate.day}`,
    );
    this.form.patchValue({
      date: date,
    });
    this.form.updateValueAndValidity();
  }

  onIncreaseMinors() {
    // if (
    //   this.readonly &&
    //   !confirm('you will be required to enter the passager details again ')
    // ) {
    //   return;
    // }
    let passenger = this.passenger?.value;
    let minor = this.minor?.value;
    if (
      this.adult?.value + this.minor?.value <
      Number(this.trainConfig.maxNoOfTicketPerBooking)
    ) {
      minor++;
      passenger++;
      this.form.patchValue({
        minor: minor,
      });
      this.updatePassengers(passenger);
      return;
    }
    this.notificationService.info(
      'Maximum Passengers',
      `maximum number of tickets per booking exceeded`,
    );
    // todo: notify user that they have reached maximum capacity
  }

  onDecreaseMinors() {
    // if (
    //   this.readonly &&
    //   !confirm('you will be required to enter the passager details again ')
    // ) {
    //   return;
    // }
    let passenger = this.passenger?.value;
    let minor = this.minor?.value;
    if (this.adult?.value + this.minor?.value > 1) {
      minor--;
      passenger--;
      this.form.patchValue({
        minor: minor,
      });
      this.updatePassengers(passenger);
      return;
    }
    // todo: notify user that they have reached minimum capacity
    this.notificationService.info(
      'Minimum Passengers',
      `minimum number of tickets per booking is 1`,
    );
  }

  onIncreaseAdults() {
    // if (
    //   this.readonly &&
    //   !confirm('you will be required to enter the passager details again ')
    // ) {
    //   return;
    // }
    let passenger = this.passenger?.value;
    let adult = this.adult?.value;
    if (
      this.adult?.value + this.minor?.value <
      Number(this.trainConfig.maxNoOfTicketPerBooking)
    ) {
      adult++;
      passenger++;
      this.form.patchValue({
        adult: adult,
      });
      this.updatePassengers(passenger);
      return;
    }
    this.notificationService.info(
      'Maximum Passengers',
      `maximum number of tickets per booking exceeded`,
    );
    // todo: notify user that they have reached maximum capacity
  }

  onDecreaseAdults() {
    // if (
    //   this.readonly &&
    //   !confirm('you will be required to enter the passager details again ')
    // ) {
    //   return;
    // }
    let passenger = this.passenger?.value;
    let adult = this.adult?.value;
    if (this.adult?.value + this.minor?.value > 1) {
      adult--;
      passenger--;
      this.form.patchValue({
        adult: adult,
      });
      this.updatePassengers(passenger);
      return;
    }
    // todo: notify user that they have reached minimum capacity
    this.notificationService.info(
      'Minimum Passengers',
      `minimum number of tickets per booking is 1`,
    );
  }

  // onIncreasePassenger() {
  //   let passenger = this.passenger?.value;
  //   if (passenger < Number(this.trainConfig.maxNoOfTicketPerBooking)) {
  //     passenger++;
  //     this.updatePassengers(passenger);
  //     return;
  //   }
  //   this.notificationService.info(
  //     'Maximum Passengers',
  //     `maximum number of tickets per booking exceeded`
  //   );
  //   // todo: notify user that they have reached maximum capacity
  // }

  // onDecreasePassenger() {
  //   let passenger = this.passenger?.value;
  //   if (passenger > 1) {
  //     passenger--;
  //     this.updatePassengers(passenger);
  //     return;
  //   }
  //   // todo: notify user that they have reached minimum capacity
  //   this.notificationService.info(
  //     'Minimum Passengers',
  //     `minimum number of tickets per booking is 1`
  //   );
  // }

  onSearchAvailableTrains() {
    if (!this.isAuth) {
      this.dialogService.openLoginDialog().result.then(
        () => {
          this.breezeService.reportAuthReady$
            .pipe(
              filter((ready) => ready),
              take(1),
            )
            .subscribe(() => {
              this.getserverTime();
              this.loadBannerMessage();
            });
          this.performSearch();
        },
        () => {
          // user dismissed the login dialog without logging in
        },
      );
      return;
    }
    this.performSearch();
  }

  private performSearch() {
    this.updateSearchParams();
    this.dialogService.openLoadingTripsDialog(
      'Finding the best fares for you',
      'Just a moment...',
    );
    this.gettingSearchResults = true;
    const data = {
      date: this.datePipe.transform(this.form.value.date, 'yyyyMMddHHmmss'),
      destinationStation1: this.form.value.destinationStation1,
      sourceStation1: this.form.value.sourceStation1,
    };
    this.breezeService.getTrains(data);
  }

  getProductList() {
    this.breezeService.getProductList().subscribe((res: any) => {
      this.productList = res?.productInfo.filter(
        (e: any) => e.label !== 'Special Needs',
      );
    });
  }

  onModify() {
    this.dialogService
      .confirm(
        'Are you sure?',
        'Passenger details and seat allocation will be lost',
      )
      .result.then(
        () => {
          this.router.navigate(['/']);
        },
        () => {
          // do nothing
        },
      );
  }

  updateSearchParams() {
    this.breezeService.setSearchParams(this.form.value);
  }

  displayComingSoon() {
    this.notificationService.info(
      'Coming Soon!',
      'The best things take time. We are currently working to offer you the best services - watch this space.',
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
